module.exports = __webpack_public_path__ + "fonts/inter-v3-latin-300.9649f6b.woff2";